import { lazy } from "react";
const Dashboard = lazy(() => import("../src/Components/Dashboard/Dashboard"));
const UserManagement = lazy(() =>
  import("../src/Components/UserManagement/UserManagement")
);
const GroupManagement = lazy(() =>
  import("../src/Components/UserManagement/Group")
);
const Statistics1 = lazy(() =>
  import("../src/Components/UserManagement/Statistics")
);
const SubscriptionDetails = lazy(() =>
  import("../src/Components/SubscriptionDetails/SubscriptionDetails")
);
const ConnectedView = lazy(() =>
  import("../src/Components/ConnectedView/ConnectedView")
);
const PlatformSettings = lazy(() =>
  import("../src/Components/PlatformSettings/MenuManagement")
);
const MenuManagement = lazy(() =>
  import("../src/Components/PlatformSettings/MenuManagement")
);
const EnquireDetails = lazy(() =>
  import("../src/Components/EnquireDetails/EnquireDetails")
);
const OrganizationDetails = lazy(() =>
  import("../src/Components/OrganizationDetails/OrganizationDetails.js")
);
const TwoFactor = lazy(() => import("../src/Components/TwoFactor/TwoFactor"));
const OrgInfo = lazy(() =>
  import("../src/Components/Organizationinfo/Orginfo")
);
const OrganizationSubsciption = lazy(() =>
  import("../src/Components/Organizationinfo/Subscription")
);
const OrganizationGroup = lazy(() =>
  import("../src/Components/Organizationinfo/Group")
);
const OrganizationInfo = lazy(() =>
  import("../src/Components/Organizationinfo/Organizationinfo")
);
const Userdetails = lazy(() =>
  import("../src/Components/Organizationinfo/Userdetails")
);
const SSO = lazy(() =>
  import("../src/Components/Organizationinfo/SSoSettings")
);
const Statistics = lazy(() =>
  import("../src/Components/Organizationinfo/Statistics")
);

const SettingDetails = lazy(() =>
  import("../src/Components/OrganizationDetails/SettingDetails")
);
const UserSessions = lazy(() =>
  import("../src/Components/OrganizationDetails/UserSessions")
);
const OrgUserSessions = lazy(() =>
  import("../src/Components/UserSessions/OrgUserSessions.js")
);
const EmailManagement = lazy(() =>
  import("../src/Components/OrganizationDetails/EmailManagement")
);
const userroutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "mdi mdi-view-dashboard menu-icon",
    component: Dashboard,
    level: 1,
  },
  {
    path: "/UserManagement",
    name: "User Management",
    icon: "mdi mdi-account-group menu-icon",
    component: UserManagement,
    level: 1,
  },
  {
    path: "/GroupManagement",
    name: "Groups",
    icon: "mdi mdi-account-group menu-icon",
    component: GroupManagement,
    level: 1,
  },
  {
    path: "/subscriptionDetails",
    name: "Subscription Details",
    icon: "mdi mdi-account-details-outline menu-icon",
    component: SubscriptionDetails,
    level: 1,
  },
  {
    path: "/OrgUserSessions.js",
    name: "User Sessions",
    icon: "mdi mdi mdi-menu",
    component: OrgUserSessions,
    level: 1,
  },
  {
    path: "/Statistics",
    name: "Statistics",
    icon: "mdi mdi-account-group menu-icon",
    component: Statistics1,
    level: 1,
  },
  {
    path: "/TwoFactor",
    name: "Privacy & Setting",
    icon: "mdi mdi-account-cog menu-icon",
    component: TwoFactor,
    level: 1,
  },
  // {
  //   path: "/ConnectedView",
  //   name: "Connected View",
  //   icon: "mdi mdi-web",
  //   component: ConnectedView,
  //   level: 3,
  // },
  {
    path: "/EnquireDetails",
    name: "Enquiry/Signup Forms",
    icon: "mdi mdi-calendar menu-icon",
    component: EnquireDetails,
    level: 3,
  },

  {
    path: "/OrganizationDetails",
    name: "Organization List",
    icon: `mdi mdi-account-alert menu-icon`,
    component: OrganizationDetails,
    MasterTab: {
      name: "Organization",
      component: OrganizationInfo,
      path: "/OrganizationDetails/Organization",
    },
    tab: [
      {
        component: OrgInfo,
        name: "Organization Information",
        path: "/OrganizationDetails/Organization/info",
      },
      {
        component: OrganizationSubsciption,
        name: "Subscription Details",
        path: "/OrganizationDetails/Organization/Subscription",
      },
      {
        component: Userdetails,
        name: "User Details",
        path: "/OrganizationDetails/Organization/user",
      },
      {
        component: OrganizationGroup,
        name: "Group Details",
        path: "/OrganizationDetails/Organization/group",
      },
      {
        component: SSO,
        name: "Single Sign On Settings",
        path: "/OrganizationDetails/Organization/sso",
      },
      {
        component: Statistics,
        name: "Statistics",
        path: "/OrganizationDetails/Organization/Statistics",
      },
      {
        component: SettingDetails,
        name: "Setting Details",
        path: "/OrganizationDetails/Organization/SettingDetails",
      },
      {
        component: UserSessions,
        name: "User Sessions",
        path: "/OrganizationDetails/Organization/UserSessions",
      },
        {
        component: EmailManagement,
        name: "Email settings",
        path: "/OrganizationDetails/Organization/emailsettings",
      },
    ],
    level: 3,
  },
  {
    path: "/platformsettings",
    name: "Platform Settings",
    icon: "mdi mdi-message-settings-variant",
    component: PlatformSettings,
    level: 3,
  },
  {
    path: "/TwoFactor",
    name: "Privacy & Setting",
    icon: "mdi mdi-settings menu-icon",
    component: TwoFactor,
    level: 3,
  },
];
export default userroutes;
